"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeObjects = exports.identity = exports.getBoolean = exports.isMap = exports.isNullOrUndefined = void 0;
function isNullOrUndefined(value) {
    return value === undefined || value === null;
}
exports.isNullOrUndefined = isNullOrUndefined;
function isMap(value) {
    return value && typeof value.has === 'function' && typeof value.get === 'function';
}
exports.isMap = isMap;
function getBoolean(value, fallback) {
    if (fallback === void 0) { fallback = false; }
    if (isNullOrUndefined(value)) {
        return fallback;
    }
    return !!value;
}
exports.getBoolean = getBoolean;
function identity(v) {
    return v;
}
exports.identity = identity;
/**
 * 合并对象，但是undefined值不覆盖之前的对象
 */
function mergeObjects(target, source) {
    var result = __assign({}, (target || {}));
    Object.keys(source || {}).forEach(function (key) {
        if (source[key] !== undefined) {
            result[key] = source[key];
        }
    });
    return result;
}
exports.mergeObjects = mergeObjects;
